import { AdminTranslations } from '../types';

export const admin: AdminTranslations = {
  dashboard: {
    title: 'Gándara Admin Dashboard',
    subtitle: 'Admin Access (Session-based)',
    signOut: 'Sign Out',
    renewalRequests: 'Renewal Requests',
    requestsCount: 'request total',
    requestsCountPlural: 'requests total',
    noRequests: 'No renewal requests yet',
    noRequestsHint: 'Submissions will appear here as families complete the renewal form',
    loading: 'Loading renewals...',
    exportCsv: 'Export CSV',
  },
  filters: {
    placeholder: 'Search by name, email, phone or child name...',
    dateFrom: 'From',
    dateTo: 'To',
    paymentStatus: 'Payment status',
    all: 'All',
    paid: 'Paid',
    unpaid: 'Unpaid',
    today: 'Today',
    thisWeek: 'This week',
    thisMonth: 'This month',
    clearFilters: 'Clear filters',
    search: 'Search',
  },
  table: {
    date: 'Date',
    parent: 'Parent',
    children: 'Children',
    pricing: 'Pricing',
    status: 'Status',
    notes: 'Notes',
    annual: 'Annual',
    monthly: 'Monthly',
  },
  payment: {
    title: 'Payment Status',
    paid: 'Paid',
    unpaid: 'Unpaid',
    date: 'Payment date',
    dateRequired: 'Payment date is required when marking as paid',
    notes: 'Payment notes',
    notesPlaceholder: 'Transfer number, reference, etc.',
    save: 'Save',
    saving: 'Saving...',
    saved: 'Payment status updated',
    error: 'Error updating payment',
  },
  notes: {
    title: 'Admin Notes',
    placeholder: 'Add a note...',
    add: 'Add',
    adding: 'Adding...',
    empty: 'No notes yet',
    error: 'Error adding note',
  },
  details: {
    contactInfo: 'Contact Information',
    email: 'Email',
    phone: 'Phone',
    language: 'Language',
    children: 'Children',
    birthDate: 'Birth Date',
    level: 'Level',
    childOrder: 'child',
    pricing: 'Pricing Details',
    matriculaTotal: 'Matricula Total',
    annualTuition: 'Annual Tuition',
    earlyBirdDiscount: 'Early Bird Discount',
    annualDiscount: 'Annual Payment Discount',
    paymentType: 'Payment Type',
    annualPayment: 'Annual',
    monthlyPayment: 'Monthly (10 months)',
    services: 'Interested Services',
    transport: 'Transport',
    comedor: 'Comedor',
    aulaMadruga: 'Aula Madruga',
    noServices: 'No additional services selected',
    comments: 'Comments',
  },
};
